enum PerformanceTestStatus {
  SCHEDULED = "scheduled",
  RESCHEDULED = "rescheduled",
  PASSED = "passed",
  ISSUE = "issue",
  RUNNING = "running",
}

export default PerformanceTestStatus
